var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5 2.23333C12.7732 2.23333 15.6923 4.07933 17.1173 7C15.6923 9.92067 12.7818 11.7667 9.5 11.7667C6.21818 11.7667 3.30773 9.92067 1.88273 7C3.30773 4.07933 6.22682 2.23333 9.5 2.23333ZM9.5 0.5C5.18182 0.5 1.49409 3.19533 0 7C1.49409 10.8047 5.18182 13.5 9.5 13.5C13.8182 13.5 17.5059 10.8047 19 7C17.5059 3.19533 13.8182 0.5 9.5 0.5ZM9.5 4.83333C10.6918 4.83333 11.6591 5.804 11.6591 7C11.6591 8.196 10.6918 9.16667 9.5 9.16667C8.30818 9.16667 7.34091 8.196 7.34091 7C7.34091 5.804 8.30818 4.83333 9.5 4.83333ZM9.5 3.1C7.35818 3.1 5.61364 4.85067 5.61364 7C5.61364 9.14933 7.35818 10.9 9.5 10.9C11.6418 10.9 13.3864 9.14933 13.3864 7C13.3864 4.85067 11.6418 3.1 9.5 3.1Z",
    fill: "#1D191B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ecab3da02d834f2fe936f5fa4896ca86.svg";
export { ForwardRef as ReactComponent };